
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Trial from "../pages/trial/page";
import ContactNow from "../pages/contact-now/page";
import Contact from "../pages/contact/page";
import StartNow from "../pages/start-now/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/trial",
    element: <Trial />,
  },
  {
    path: "/contact-now",
    element: <ContactNow />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/start-now",
    element: <StartNow />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
